module.exports = __webpack_public_path__ + "img/files-upload.17aabce9.svg";